import _ from 'lodash';
import { adapi, Debug } from '~';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { mapActions, mapGetters } from 'vuex';

const debug = Debug('lead-contact-box');

function fixPhone(phone) {
  return phone.trim().replace(' ', '');
}

function fixEmail(email) {
  return email.trim();
}

export default {
  components: {
    'box-widget': BoxWidget,
  },
  data() {
    return {
      changing: false,
      newPhones: [],
      newEmails: [],
    };
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
    }),
    customerPhone() {
      return fixPhone(_.get(this, 'campaign.customer.phone', ''));
    },
    customerEmail() {
      return fixEmail(_.get(this, 'campaign.customer.email', ''));
    },
    campaignPhones() {
      const detailPhones = _.get(this, 'campaign.details', [])
        .filter(d => d.name === 'leadPhone')
        .map(d => d.value.split(','))[0] || [];

      return detailPhones.map(p => fixPhone(p));
    },
    campaignEmails() {
      const detailPhones = _.get(this, 'campaign.details', [])
        .filter(d => d.name === 'leadEmail')
        .map(d => d.value.split(','))[0] || [];

      return detailPhones.map(p => fixEmail(p));
    },
  },
  methods: {
    ...mapActions('campaign', ['reloadCampaign']),
    changeLeadContacts() {
      debug.info('Change contacts');
      const phones = this.newPhones
        .map(p => fixPhone(p))
        .filter(p => p.length);

      const emails = this.newEmails
        .map(e => fixEmail(e))
        .filter(e => e.length);

      debug.info('New contacts:', phones, emails);

      this.changing = true;
      adapi.post(`campaigns/${this.campaign.code}/lead-contacts`, null, {
        phones,
        emails,
      })
        .then(() => {
          debug.info('change successful');
          this.$toast.success({ message: this.$t('pos.lead-contacts.success') });
          this.changing = false;
          this.cancelModal();
          this.reloadCampaign();
        })
        .catch(error => {
          debug.info('change failed');
          this.$toast.error({ message: error.toString() });
          this.changing = false;
        });
    },
    cancelModal() {
      debug.debug('Cancel modal');
      this.$refs.modal.hide();
    },
    openModal() {
      debug.debug('Open modal');
      const MAX_ENTRY_COUNT = 6;

      this.newEmails = new Array(MAX_ENTRY_COUNT);
      this.newEmails.fill('');
      this.campaignEmails.forEach((email, index) => this.newEmails[index] = email);

      this.newPhones = new Array(MAX_ENTRY_COUNT);
      this.newPhones.fill('');
      this.campaignPhones.forEach((phone, index) => this.newPhones[index] = phone);

      this.$refs.modal.show();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/lead-contact-box/LeadContactBox.js